<template>
    <div v-if="allProducts.length">
        <div class="flex flex-wrap -mx-4 -mb-8">
            <ProductItem
                :class="`lg:w-1/${productsOnRow}`"
                v-for="(product, key) in allProducts"
                :list-title="listTitle"
                :product="product"
                :index="key"
                :is-option-selected="isOptionSelected"
                :selected-options="selectedOptions"
                :opened-slide="openedSlide"
                @slideOpened="openedSlide = $event"
            />
        </div>
        <Pagination
            :on-more-loaded="onMoreLoaded"
            :on-page-loaded="onPageLoaded"
            :get-additional-query-params="queryParams"
            model-name="products"
            :base-url="baseUrl"
            :items="products"
        />
    </div>

    <div v-else class="flex justify-center">
        <div>
            <h2 class="text-2xl font-bold my-10">Результатів не знайдено</h2>

            <slot name="no-results"/>
        </div>
    </div>
</template>

<script>
import Pagination from "@/Components/Pagination.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import ProductItem from "@/Components/Products/Partials/ProductItem.vue";
import {ecommerce} from "@/Helpers/zaraz.js";
import {router} from "@inertiajs/vue3";

export default {
    components: {ProductItem, PrimaryButton, Pagination},
    props: {
        products: Object,
        queryParams: {
            type: Function,
            default: () => {}
        },
        baseUrl: {
            type: String,
            required: true,
        },
        listTitle: {
            type: String,
            required: true,
        },
        productsOnRow: {
            default: 3
        }
    },
    data () {
        return {
            allProducts: this.products.data,
            selectedOptions: [],
            openedSlide: null,
        }
    },
    methods: {
        isOptionSelected(modification, option) {
            const options = this.selectedOptions
                .find((options) => options.modification_id === modification.id)
                .options

            return options.includes(option.id) ||
                (
                    modification.options[0].id === option.id &&
                    !modification.options.find(opt => options.includes(opt.id))
                )
        },
        onMoreLoaded(products) {
            this.allProducts = this.allProducts.concat(products.data)

            this.syncProducts(products.data)
        },
        toPage(page, preserveScroll = false, preserveState = false, only = []) {
            router.visit(this.baseUrl, {
                data: {...this.queryParams(), page},
                only: ['products', ...only],
                preserveScroll,
                preserveState,
                onSuccess: (data) => this.onPageLoaded(data.props.products)
            })
        },
        onPageLoaded(products) {
            this.allProducts = products.data

            this.$emit('total-updated', products.meta.total)

            this.$emit('page-loaded')

            this.syncProducts(products.data)
        },
        syncProducts(products) {
            products.forEach(product => {
                product.modifications.forEach(modification => {
                    if (this.selectedOptions.find((options) => options.modification_id === modification.id)) {
                        return
                    }

                    const options = []

                    modification.options.forEach(option => {
                        if (option.is_default || modification.options.length === 1) {
                            options.push(option.id)
                        }
                    })

                    this.selectedOptions.push({
                        modification_id: modification.id,
                        options
                    })
                })
            })

            ecommerce('Product List Viewed', products, {
                category: this.listTitle,
            })
        },
    },
    created() {
        this.syncProducts(this.products.data)
    }
}
</script>
